export default __webpack_public_path__ + "static/media/placeholder-image-circle.4fe2b8f2.png";